import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { Heart, Sparkles, ShoppingCart, Search, ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

export default function AdvertiserOverview() {
  const { user } = useOutletContext();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/advertiser/overview").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="advertiser-overview">
      <div className="text-[11px] uppercase tracking-[0.3em] font-semibold text-[var(--gold)]">Console · Advertiser</div>
      <h1 className="mt-3 font-serif-display text-4xl lg:text-5xl text-[var(--ink)]">
        Welcome, <span className="font-serif-italic text-[var(--gold)]">{user?.name?.split(" ")[0]}.</span>
      </h1>
      <p className="mt-2 text-[var(--slate-1)]">Your campaigns, shortlists and AI plans — in one place.</p>

      <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-px bg-[var(--border)]">
        <Card icon={Heart} label="Shortlisted spaces" value={stats?.shortlist} to="/advertiser/shortlist" />
        <Card icon={Sparkles} label="AI plans" value={stats?.ai_plans} to="/advertiser/plans" />
        <Card icon={ShoppingCart} label="Orders placed" value={stats?.orders} to="/advertiser/orders" />
        <Card icon={ShoppingCart} label="Live / confirmed" value={stats?.orders_active} to="/advertiser/orders" />
      </div>

      <div className="mt-14 grid grid-cols-1 lg:grid-cols-3 gap-4">
        <QuickAction title="Browse marketplace" body="3,759 live ad spaces across 47 cities." cta="Open marketplace" to="/marketplace" icon={Search} />
        <QuickAction title="Plan with AI" body="Get a buyable proposal in 90 seconds." cta="Open AI Planner" to="/ai-planner" icon={Sparkles} />
        <QuickAction title="View shortlist" body="Send shortlisted placements as a proposal." cta="Open shortlist" to="/advertiser/shortlist" icon={Heart} />
      </div>
    </div>
  );
}

function Card({ icon: Icon, label, value, to }) {
  return (
    <Link to={to} className="bg-[var(--bone)] p-6 hover:bg-white transition" data-testid={`adv-card-${label.split(" ")[0].toLowerCase()}`}>
      <div className="flex items-center justify-between">
        <Icon size={18} className="text-[var(--gold)]" />
        <ArrowUpRight size={14} className="text-[var(--slate-2)]" />
      </div>
      <div className="mt-5 font-serif-display text-4xl text-[var(--ink)]">{value ?? "—"}</div>
      <div className="mt-1 text-[10px] uppercase tracking-[0.22em] text-[var(--slate-2)]">{label}</div>
    </Link>
  );
}

function QuickAction({ title, body, cta, to, icon: Icon }) {
  return (
    <Link to={to} className="surface surface-hover p-6 group">
      <Icon size={20} className="text-[var(--gold)]" strokeWidth={1.4} />
      <div className="mt-4 font-serif-display text-2xl text-[var(--ink)]">{title}</div>
      <p className="mt-2 text-sm text-[var(--slate-1)]">{body}</p>
      <div className="mt-5 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] font-semibold text-[var(--gold)]">
        {cta} <ArrowUpRight size={11} />
      </div>
    </Link>
  );
}
